/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Usercustompages2Inputs */

const en_entity_usercustompages2 = /** @type {(inputs: Entity_Usercustompages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Custom Pages`)
};

const de_entity_usercustompages2 = /** @type {(inputs: Entity_Usercustompages2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusatzseiten`)
};

/**
* | output |
* | --- |
* | "User Custom Pages" |
*
* @param {Entity_Usercustompages2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_usercustompages2 = /** @type {((inputs?: Entity_Usercustompages2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Usercustompages2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_usercustompages2(inputs)
	return de_entity_usercustompages2(inputs)
});
export { entity_usercustompages2 as "entity_userCustomPages" }